import { useQuery } from '@apollo/client'
import { Platforms } from 'src/interfaces/types/app'

import { FILTER_BRANDS } from '../queries/filterBrands'
import { LIST_BRANDS_PRODUCTS } from '../queries/ListSpecificBrands'

interface InputFilterBrands {
  q: string
  categories: string[]
}

export interface Brands {
  name: string
  logoUrl: string | null
  urlStore: string | null
}

export const useGetFilterBrands = (input: InputFilterBrands) => {
  return useQuery(FILTER_BRANDS, {
    variables: {
      input,
    },
    context: {
      clientName: 'business',
    },
  })
}

export type ListSpecificBrands = { listSpecificBrands?: Brands[] }
export const useListBrands = () => {
  return useQuery<ListSpecificBrands>(LIST_BRANDS_PRODUCTS, {
    context: { clientName: Platforms.business },
    variables: {},
  })
}
